import { render } from "./checkbox-round.vue?vue&type=template&id=d2a1b180&ts=true"
import script from "./checkbox-round.vue?vue&type=script&lang=ts"
export * from "./checkbox-round.vue?vue&type=script&lang=ts"

import "./checkbox-round.vue?vue&type=style&index=0&id=d2a1b180&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__